import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { BreadcrumbComponent } from 'xng-breadcrumb';

@Component({
  standalone:true,
  imports:[MatIconModule,CommonModule,BreadcrumbComponent ],
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css'],
})
export class MyBreadcrumbComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
